export default "<iframe [src]=\"data | safeurl\"></iframe>\r\n";